import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Thumbnail from "../../../lib/Thumbnail";
import {addPrefix} from "../../../utils/UriUtil";
import {jsonResponseHandler, revenueResponseHandler} from "../../../utils/FetchHelper";
import {number_format} from "../../../utils/formatter";

const RevenuePrediction = ({expectData, close}) => {
  const [transition, setTransition] = useState(true);
  const [delay, setDelay] = useState(0.3);
  const [value, setValue] = useState(0);

  const blog = useSelector(state => state.blog);
  const {image} = blog;

  const handleChangeProgress = (e) => {
    if (e.target.value < 40) {
      setValue(40);
    } else {
      setValue(e.target.value);
    }
  };
  const getPvByValue = (value) => {
    let pv;
    if (value >= 0 && value < 200) {
      pv = 5000 * (value / 200)
    } else if (value >= 200 && value < 400) {
      pv = 5000 + (5000 * ((value - 200) / 200));
    } else if (value >= 400 && value < 600) {
      pv = 10000 + (90000 * ((value - 400) / 200));
    } else if (value >= 600 && value < 800) {
      pv = 100000 + (100000 * ((value - 600) / 200));
    } else if (value >= 800) {
      pv = 200000 + (300000 * ((value - 800) / 200));
    }
    return Math.floor(pv);
  };

  const getMinByPv = (pv) => {
    if (expectData) {
      const typeData1 = expectData['320x100'];
      const type320x100eCPM = typeData1.profit / typeData1.expose * 1000;
      const typeData2 = expectData['250x250'];
      const type250x250eCPM = typeData2.profit / typeData2.expose * 1000;
      return Math.round(pv * (type320x100eCPM * 3 + type250x250eCPM) / 1000 * 365);
    } else {
      return 0;
    }
  };
  const getMaxByPv = (pv) => {
    if (expectData) {
      const typeData1 = expectData['320x100'];
      const type320x100eCPVM = typeData1.profit / typeData1.exposeViewable * 1000;
      const typeData2 = expectData['250x250'];
      const type250x250eCPVM = typeData2.profit / typeData2.exposeViewable * 1000;
      return Math.round(pv * (type320x100eCPVM * 3 + type250x250eCPVM) / 1000 * 365);
    } else {
      return 0;
    }
  };
  const getPositionOfMyBlog = () => {
    const positionOfZero = 97;
    const widthOfOneBlock = 135.6;
    if (expectData) {
      const pv = expectData.myPv;
      if (pv >= 0 && pv < 5000) {
        return positionOfZero + (widthOfOneBlock * pv / 5000);
      } else if (pv >= 5000 && pv < 10000) {
        return positionOfZero + widthOfOneBlock + (widthOfOneBlock * (pv - 5000) / 5000);
      } else if (pv >= 10000 && pv < 100000) {
        return positionOfZero + widthOfOneBlock * 2 + (widthOfOneBlock * (pv - 10000) / 90000);
      } else if (pv >= 100000 && pv < 200000) {
        return positionOfZero + widthOfOneBlock * 3 + (widthOfOneBlock * (pv - 100000) / 100000);
      } else if (pv >= 200000 && pv < 500000) {
        return positionOfZero + widthOfOneBlock * 4 + (widthOfOneBlock * (pv - 200000) / 300000);
      } else {
        return positionOfZero + widthOfOneBlock * 5;
      }
    } else {
      return positionOfZero;
    }
  };

  useInterval(() => {
    if (value >= 199) {
      setTransition(false);
    }
    if (value < 90) {
      setValue(value + 2);
      setDelay(1);
    } else if (value < 170) {
      setValue(value + 1);
      setDelay(3);
    } else {
      setValue(value + 1);
      setDelay(7);
    }
  }, value < 200 && transition ? delay : null);

  function useInterval(callback, delay) {
    const savedCallback = useRef();
    useEffect(() => {
      savedCallback.current = callback;
    });
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }

      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay])
  }

  return (
    <div className="box_blog box_revenue box_revenue_type2">
      <strong className="tit_blog_type1"><em>내 블로그 수익</em> 예측하기</strong>
      <p className="desc_blog">블로그 방문수로 추정한 내 블로그의 예상 수익입니다.<br/>연동 플랫폼, 광고 수에 따라 실제 수익과 차이가 날 수 있습니다.</p>
      <div className="expected_advantage">
        <div className="layer_popup" style={{transform: `translateX(${672 * value / 1000}px)`}}>
          <div className="inner_popup inner_popup_type1">
            <strong className="tit_popup">예상 연수익</strong>
            <div className="expected_range">
              <span className="ir_pm">최저</span>
              <span className="num_type1">
                                {number_format(getMinByPv(getPvByValue(value)))} ~
                            </span>
              <span className="ir_pm">최고</span>
              <span className="num_type2">
                                {number_format(getMaxByPv(getPvByValue(value)))}
                <em>원</em>
                            </span>
            </div>
            <span className="ico_blog ico_money_won01"/>
          </div>
        </div>
        <div className="progress_bar">
          <label htmlFor="dayVisotor">일 방문수</label>
          <span className="state_value">{number_format(getPvByValue(value))}</span>
          <div className="wrap_inp">
            <span className="range_value" style={{width: `${value / 10}%`}}>{value / 10}</span>
            <input type="range" className="inp_range" id="dayVisotor" min="0" max="1000" value={value}
                   onChange={handleChangeProgress}/>
          </div>
          <div className="wrap_unit">
            <div className="data_unit unit_1">0</div>
            <div className="data_unit unit_2">5,000</div>
            <div className="data_unit unit_3">1만</div>
            <div className="data_unit unit_4">10만</div>
            <div className="data_unit unit_5">20만~</div>
            <div className="data_unit unit_6">50만~</div>
          </div>
          <div className="my_range" style={{left: getPositionOfMyBlog()}}>
            <span className="ico_blog ico_pointer"/>
            <span className="thumb_profile"
                  style={{backgroundImage: `url(${Thumbnail.make('C428x428', image)})`}}>아이디</span>
            <span className="txt_g">내 블로그</span>
          </div>
        </div>
      </div>
      <button className="ico_blog ico_close_type1" onClick={close}>닫기</button>
    </div>
  )
};

const TopContents = ({onClickConnectAdfitButton}) => {
  const dispatch = useDispatch();
  const revenue = useSelector(state => state.revenue);
  const [view, setView] = useState('loading');
  const [blogCreatedDays, setBlogCreatedDays] = useState(0);
  const [entryCount, setEntryCount] = useState(0);
  const [predictLayerOn, setPredictLayerOn] = useState(false);
  const [expectData, setExpectData] = useState(null);

  const getRandInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const [rand, setRand] = useState(getRandInt(1,3));

  const getMaxByPv = (pv) => {
    if (expectData) {
      const typeData1 = expectData['320x100'];
      const type320x100eCPVM = typeData1.profit / typeData1.exposeViewable * 1000;
      const typeData2 = expectData['250x250'];
      const type250x250eCPVM = typeData2.profit / typeData2.exposeViewable * 1000;
      return Math.round(pv * (type320x100eCPVM * 3 + type250x250eCPVM) / 1000 * 365);
    } else {
      return 0;
    }
  };
  const overThousand = () => {
    return expectData && expectData.myPv >= 1000;
  };

  useEffect(() => {
    if (revenue.adfitInfo) {
      const {blogCreatedDays, entryCount} = revenue.adfitInfo.requirementInfo;
      setBlogCreatedDays(blogCreatedDays);
      setEntryCount(entryCount);
      if (
        revenue.adfitInfo.accountCode === 'SUCCESS' &&
        revenue.adfitInfo.accountResultCode === '000'
      ) {
        setView('nothing');
      } else {
        if (blogCreatedDays >= 30 && entryCount >= 20) {
          setView('button');
        } else {
          setView('requirement');
        }
      }
    } else {
      setView('loading')
    }
  }, [revenue]);

  useEffect(() => {
    fetch(addPrefix('/manage/revenue/expectedEarnings/adfit.json'),
      {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then(jsonResponseHandler(dispatch))
      .then(revenueResponseHandler(dispatch))
      .then(r => r.json())
      .then((data) => {
        setExpectData(data.data);
      })
      .catch(() => {
      });
  }, []);

  if (predictLayerOn) {
    return (
      <RevenuePrediction
        expectData={expectData}
        close={() => setPredictLayerOn(false)}
      />
    )
  } else {
    return (
      <div className="box_blog box_revenue">
        <span className="bg_box_type1" style={{
          backgroundImage: `url(//t1.daumcdn.net/tistory_admin/static/manage/images/temp/bg_img_0${rand}.svg)`
        }}/>
        <strong className="tit_blog">
          <em>당신의</em>
          {' 소중한 이야기가'}
          <br/>
          {!overThousand() &&
          <>
            <em>값진 수익</em>
            <span className="ico_blog ico_money_won">원</span>
            이 됩니다
          </>
          }
          {overThousand() &&
          <>
            <em className="num_em">{number_format(getMaxByPv(expectData.myPv))}</em>
            <span className="ico_blog ico_money_won">원</span>
            수익이 됩니다.
          </>
          }
        </strong>
        <p className="desc_blog">
          심사부터 수익까지 티스토리에서 한 번에
          <br/>
          광고를 노출하고 수익을 극대화하세요.
        </p>
        {view === 'button' &&
        <a className="btn_type3" onClick={onClickConnectAdfitButton}>AdFit 광고 연동하기</a>
        }
        {view === 'requirement' &&
        <div className="revenue_state">
          <strong className="screen_out">현재상황</strong>
          <ul className="list_state">
            <li className={blogCreatedDays >= 30 ? 'on' : ''}>
              <span className="ico_blog ico_check_type2"/>
              {`블로그 개설일 ${blogCreatedDays < 30 ? `${blogCreatedDays}/30` : ``}`}
            </li>
            <li className={entryCount >= 20 ? 'on' : ''}>
              <span className="ico_blog ico_check_type2"/>
              {`3개월 내 발행 글 ${entryCount < 20 ? `${entryCount}/20` : ``}`}
            </li>
          </ul>
        </div>
        }
        <div className="revenue_advantage">
          <strong className="screen_out">티스토리_광고 플랫폼 연결 장점</strong>
          <ul className="list_revenue">
            <li><span className="ico_blog ico_advantage01"/><span
              className="txt_g">심사, 광고, 수익 확인까지 <br/>한———번에 해보세요.</span>
            </li>
            <li><span className="ico_blog ico_advantage02"/><span className="txt_g">복잡한  HTML 편집 없이 <br/>손쉽게 광고를 노출하세요.</span>
            </li>
            <li><span className="ico_blog ico_advantage03"/><span className="txt_g">통계, 수익 분석으로 <br/>수익을 극대화하세요.</span>
            </li>
          </ul>
        </div>
        <a className="btn_cancel" onClick={() => setPredictLayerOn(true)}>
          <span className="ico_blog ico_report"/>수익 예측하기
        </a>
      </div>
    )
  }
};

export default TopContents;